<template>
  <div style="overflow: hidden; margin-top: -1.8rem">
    <div class="mb-3 d-flex" style="gap: 10px">
      <button
        class="btn-info tab-btn"
        @click="goBack"
        v-if="auth.user.userType === 'super-admin'"
      >
        Back
      </button>

      <button class="btn-approve tab-btn" @click="handleApproveKYC">
        approve kyc
      </button>

      <button class="btn-rejected tab-btn" @click="showModal = true">
        reject kyc
      </button>

      <button class="btn-info tab-btn">refresh</button>

      <div>
        <Modal
          :visible="showModal"
          :agentId="agent._id"
          @close="showModal = false"
        >
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              gap: 16px;
            "
          >
            <p
              style="
                text-align: center;
                font-size: 12px;
                color: #000;
                font-weight: 700;
              "
            >
              You are attempting to reject KYC submission
            </p>

            <label for="defaultReason" style="color: #9a9a9a; font-size: 12px"
              >Select Reason:</label
            >
            <select
              id="defaultReason"
              v-model="defaultReason"
              class="form-control op-border styled-dropdown"
            >
              <option disabled value="">Select</option>
              <option value="Blurred or Unclear Document">
                Blurred or Unclear Document
              </option>
              <option value="Expired Document">Expired Document</option>
              <option value="Document Mismatch">Document Mismatch</option>
            </select>

            <div
              class="d-flex"
              style="flex-direction: column; gap: 6px; align-items: center"
            >
              <button
                class="btn btn-info"
                style="border-radius: 18px; width: 35%"
                @click="handleRejectKYC"
              >
                SEND
              </button>

              <button
                class="btn mt-3 to-kyc"
                style="
                  border: none;
                  background-color: transparent;
                  color: #8c8ea7;
                  font-size: 12px;
                "
                @click="showModal = false"
              >
                BACK TO KYC
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </div>

    <div class="cont">
      <div class="kyc-status-content">
        <h3 class="kyc-status head-three">Status</h3>

        <h5 :class="verificationStatusClass" class="status head-five">
          {{ verificationStatusText }}
        </h5>
      </div>

      <div class="account">
        <label for="account-type">Account Type</label>
        <p class="d-flex align-items-center">
          {{
            agent && agent.accountType
              ? capitalize(agent.accountType.replace("-", " "))
              : "--"
          }}
        </p>
      </div>

      <div class="tab-items">
        <button
          v-for="section in filteredSections"
          :key="section.key"
          class="section-button"
          :class="{ active: visibleSection === section.key }"
          @click="toggleSection(section.key)"
        >
          {{ section.label }}
        </button>
      </div>

      <h3 class="heading my-n1">{{ currentSectionLabel }}</h3>

      <!--  personal information -->
      <div>
        <div v-if="visibleSection === 'personal'">
          <div v-if="agent">
            <DynamicSection :fields="personalInformation" :data="agent" />
          </div>

          <div v-else>
            <p class="no-info">No Information available for this section</p>
          </div>
        </div>

        <!--  business information -->
        <div v-if="visibleSection === 'business'">
          <div v-if="agent">
            <div>
              <DynamicSection :fields="businessInformation" :data="agent" />
            </div>

            <div class="mt-5">
              <h3 class="head-three mb-4">Source of Income</h3>

              <DynamicSection :fields="businessIncome" :data="agent" />
            </div>
          </div>

          <div v-else>
            <p class="no-info">No Information available for this section.</p>
          </div>
        </div>

        <!--  directors information -->
        <div v-if="visibleSection === 'directors'">
          <div v-if="agent.directors && agent.directors.length">
            <div style="display: flex; flex-direction: column; gap: 60px">
              <div
                v-for="(director, directorIndex) in visibleEntries.directors"
                :key="`director-${directorIndex}`"
              >
                <p class="sub-heading">Director {{ directorIndex + 1 }}</p>
                <DynamicSection :fields="allInformation" :data="director" />
              </div>
            </div>

            <span
              class="view-more"
              @click="toggleShowAllDirectors"
              v-if="agent.directors.length > 1"
            >
              {{
                showAllDirectors
                  ? "Hide additional directors"
                  : "View more directors"
              }}
            </span>
          </div>

          <div v-else>
            <p class="no-info">No Information available for this section</p>
          </div>
        </div>

        <!--  shareholders information -->
        <div v-if="visibleSection === 'shareholders'">
          <div v-if="agent.shareholders && agent.shareholders.length">
            <div style="display: flex; flex-direction: column; gap: 60px">
              <div
                v-for="(share, shareIndex) in visibleEntries.shareholders"
                :key="`share-${shareIndex}`"
              >
                <p class="sub-heading">Shareholder {{ shareIndex + 1 }}</p>
                <DynamicSection :fields="allInformation" :data="share" />
              </div>
            </div>

            <span
              class="view-more"
              @click="toggleShowAllShareholders"
              v-if="agent.shareholders.length > 1"
            >
              {{
                showAllShareholders
                  ? "Hide additional shareholders"
                  : "View more shareholders"
              }}
            </span>
          </div>

          <div v-else>
            <p class="no-info">No Information available for this section</p>
          </div>
        </div>

        <!-- trustees information -->
        <div v-if="visibleSection === 'trustees'">
          <div
            v-if="agent.registeredTrustees && agent.registeredTrustees.length"
          >
            <div style="display: flex; flex-direction: column; gap: 60px">
              <div
                v-for="(trustee, trusteeIndex) in visibleEntries.trustees"
                :key="`trustee-${trusteeIndex}`"
              >
                <p class="sub-heading">Trustee {{ trusteeIndex + 1 }}</p>
                <DynamicSection :fields="allInformation" :data="trustee" />
              </div>
            </div>

            <span
              class="view-more"
              @click="toggleShowAllTrustees"
              v-if="agent.registeredTrustees.length > 1"
            >
              {{
                showAllTrustees
                  ? "Hide additional trustees"
                  : "View more trustees"
              }}
            </span>
          </div>

          <div v-else>
            <p class="no-info">No Information available for this section</p>
          </div>
        </div>

        <!-- authorizers information -->
        <div v-if="visibleSection === 'authorizers'">
          <div
            v-if="agent.nominatedAuthorizer && agent.nominatedAuthorizer.length"
          >
            <div
              v-for="(authorizer, authorizerIndex) in agent.nominatedAuthorizer"
              :key="`authorizer-${authorizerIndex}`"
            >
              <DynamicSection :fields="allInformation" :data="authorizer" />
            </div>
          </div>

          <div v-else>
            <p class="no-info">No Information available for this section</p>
          </div>
        </div>

        <!-- kyc documents -->
        <div v-if="visibleSection === 'kyc'">
          <div v-if="agent.kycDocuments && agent.kycDocuments.length">
            <h4 class="heading">Uploaded Documents</h4>

            <div class="documents-container">
              <div
                v-for="(document, index) in agent.kycDocuments"
                :key="document._id"
              >
                <p>{{ formatDocumentName(document.name) }}</p>

                <template v-if="isImage(document.url)">
                  <div
                    class="document-wrapper"
                    :class="{ hovered: isHovered === index }"
                    @mouseover="isHovered = index"
                    @mouseleave="isHovered = null"
                  >
                    <img
                      :src="document.url"
                      :alt="`Uploaded Document: ${document.name}`"
                      class="uploaded-img"
                    />
                    <button
                      v-show="isHovered === index"
                      @click="openPreview(document.url)"
                      class="btn-normal btn-preview"
                    >
                      View
                    </button>
                  </div>
                </template>

                <template v-else>
                  <div class="pdf-preview-container">
                    <img
                      src="../assets/img/pdf.png"
                      alt="PDF Document"
                      class="pdf-icon"
                    />

                    <button
                      @click="downloadPdf(document.url)"
                      class="btn-normal btn-download"
                    >
                      Download PDF
                    </button>
                  </div>
                </template>
              </div>
            </div>

            <div v-if="showPreview" class="preview">
              <div style="position: relative; background: white; padding: 2px">
                <button @click="closePreview" class="btn-close">&times;</button>

                <img
                  :src="previewUrl"
                  alt="Preview"
                  style="max-width: 100%; max-height: 80vh"
                />
              </div>
            </div>
          </div>

          <div v-else>
            <p class="no-info">No document has been submitted.</p>
          </div>
        </div>

        <!-- aml check -->
        <div v-if="visibleSection === 'aml'">
          <div v-if="!loading.show && !amlCheck" class="centralized">
            <button
              @click="getAmlCheck"
              class="btn btn-info"
              :disabled="loading.show"
            >
              {{ loading.show ? "Checking..." : "Run AML Check" }}
            </button>
          </div>

          <span v-else-if="loading.show" class="centralized">
            <span class="spin"></span>
          </span>

          <div v-if="amlCheck" class="aml-check-container">
            <div class="aml-section">
              <div class="tab-items" style="margin: 20px 0">
                <button
                  v-for="tab in tabs"
                  :key="tab.key"
                  class="section-button"
                  :class="{ active: amlTabs === tab.key }"
                  @click="toggleTab(tab.key)"
                >
                  {{ tab.label }}
                </button>
              </div>

              <div v-if="amlTabs === 'pep'" class="aml-item">
                <div
                  v-for="(shareholder, shareholderIndex) in amlDetails
                    .business_data.business_shareholders_pep_sanction || []"
                  :key="`shareholder-${shareholderIndex}`"
                  class="aml-item"
                >
                  <div
                    v-for="(pep, pepIndex) in shareholder.pep"
                    :key="`sanction-${shareholderIndex}-${pepIndex}`"
                    class="aml-item"
                  >
                    <h3 class="head-three">
                      Business Shareholder {{ pepIndex + 1 }} PEP
                    </h3>

                    <DynamicSection :fields="businessShareholder" :data="pep" />
                  </div>
                </div>
              </div>

              <div v-if="amlTabs === 'sanction'" class="aml-item">
                <div
                  v-for="(shareholder, shareholderIndex) in amlDetails
                    .business_data.business_shareholders_pep_sanction || []"
                  :key="`shareholder-${shareholderIndex}`"
                  class="aml-item"
                >
                  <div
                    v-for="(sanction, sanctionIndex) in shareholder.sanction"
                    :key="`sanction-${shareholderIndex}-${sanctionIndex}`"
                    class="aml-item"
                  >
                    <h3 class="head-three">
                      Personal Details - Shareholder {{ shareholderIndex + 1 }}
                    </h3>

                    <DynamicSection
                      :fields="personalDetails"
                      :data="sanction"
                    />
                  </div>
                </div>

                <div
                  v-for="(sanction, sanctionIndex) in this.amlDetails
                    .sanction || []"
                  :key="`sanction-${sanctionIndex}`"
                  class="aml-item"
                >
                  <h3 class="head-three">Sanction {{ sanction.type }}</h3>

                  <DynamicSection
                    :fields="sanctionInformation"
                    :data="sanction"
                  />
                </div>
              </div>

              <div v-if="amlTabs === 'risk'" class="aml-item">
                <div
                  v-for="(amlItem, index) in amlDetailsMap"
                  :key="index"
                  class="aml-item"
                >
                  <h3 class="head-three">{{ amlItem.title }}</h3>
                  <DynamicSection
                    :fields="amlItem.fields"
                    :data="amlItem.data"
                  />
                </div>

                <div class="d-flex justify-content-center align-items-center">
                  <button @click="rerunAml" class="btn btn-info px-5">
                    Rerun
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import Swal from "sweetalert2";
import Modal from "./Modals/Modal.vue";
import DynamicSection from "../components/DynamicSection.vue";
import { mapState } from "vuex";
import {
  capitalize,
  formatDate,
  maskNumber,
  formatDocumentName,
} from "../utils/utils";
import { businessIncome } from "../constants/agents-information";
import {
  categoryTabs,
  tabs,
  sections,
  personalInformation,
  businessInformation,
  allInformation,
  businessShareholder,
  sanctionInformation,
  personalDetails,
} from "../constants/kyc";

export default {
  components: {
    Modal,
    DynamicSection,
  },
  data() {
    return {
      loading: { show: false },
      showModal: false,
      showAllDirectors: false,
      showAllShareholders: false,
      showAllTrustees: false,
      isHovered: false,
      showPreview: false,
      amlCheck: false,
      visibleSection: "personal",
      amlTabs: "pep",
      defaultReason: "",
      uploadedDocs: {},
      agent: {},
      amlDetails: {},
      categoryTabs,
      sections,
      tabs: tabs,
      personalInformation,
      businessInformation,
      allInformation,
      businessShareholder,
      sanctionInformation,
      personalDetails,
      businessIncome,
    };
  },
  computed: {
    ...mapState(["auth", "utils"]),
    filteredSections() {
      const allowedTabs = this.categoryTabs[this.agent.businessCategory] || [
        "personal",
        "business",
      ];
      return this.sections.filter((section) =>
        allowedTabs.includes(section.key),
      );
    },
    currentSectionLabel() {
      const currentSection = this.sections.find(
        (section) => section.key === this.visibleSection,
      );
      return currentSection ? currentSection.label : "";
    },
    verificationStatusClass() {
      return {
        pending: this.agent.verifiedStatus === "pending",
        rejected: this.agent.verifiedStatus === "rejected",
        verified: this.agent.verifiedStatus === "verified",
        unverified: this.agent.verifiedStatus === "Unverified",
      };
    },
    verificationStatusText() {
      return {
        pending: "Pending",
        rejected: "Rejected",
        verified: "Verified",
      }[this.agent.verifiedStatus];
    },
    visibleEntries() {
      return {
        directors: this.showAllDirectors
          ? this.agent.directors || []
          : (this.agent.directors || []).slice(0, 1),
        shareholders: this.showAllShareholders
          ? this.agent.shareholders || []
          : (this.agent.shareholders || []).slice(0, 1),
        trustees: this.showAllTrustees
          ? this.agent.registeredTrustees || []
          : (this.agent.registeredTrustees || []).slice(0, 1),
      };
    },
    currentFields() {
      const mapping = {
        personal: personalInformation,
        business: businessInformation,
        directors: allInformation,
        shareholders: allInformation,
        trustees: allInformation,
      };
      return mapping[this.visibleSection];
    },
    amlDetailsMap() {
      return [
        {
          title: "Risk Score",
          fields: { label: "Final Risk Score", key: "final_risk_score" },
          data: this.amlDetails.screening_result,
        },
        {
          title: "Risk Rank",
          fields: { label: "", key: "risk_rank" },
          data: this.amlDetails.screening_result,
        },
        {
          title: "Rank Description",
          fields: { label: "", key: "" },
          data: this.amlDetails.screening_result,
        },
      ];
    },
  },
  methods: {
    capitalize,
    formatDocumentName,
    goBack() {
      if (window.history.length > 1) this.$router.go(-1);
    },
    rerunAml() {
      this.getAmlCheck();
      this.amlTabs = "pep";
    },
    toggleSection(section) {
      this.visibleSection = section;
    },
    toggleTab(tab) {
      this.amlTabs = tab;
    },
    toggleShowAllDirectors() {
      this.showAllDirectors = !this.showAllDirectors;
    },
    toggleShowAllShareholders() {
      this.showAllShareholders = !this.showAllShareholders;
    },
    toggleShowAllTrustees() {
      this.showAllTrustees = !this.showAllTrustees;
    },
    refreshPage() {
      window.location.reload();
    },
    openPreview(url) {
      this.previewUrl = url;
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
      this.previewUrl = "";
    },
    isImage(url) {
      return /\.(jpg|jpeg|png|gif)$/i.test(url);
    },
    downloadPdf(url) {
      window.open(url, "_blank");
    },
    submit() {
      this.$confirm("Update Agent?").then(() => {
        this.updateAgent(this.agent);
      });
    },
    rejectKYC() {
      this.showModal = false;
    },
    showSuccessAlert() {
      Swal.fire({
        icon: "success",
        title: "KYC Verification Successful!",
        html: `You have verified the KYC request for  ${this.agent.firstName} ${this.agent.lastName} with assigned Wallet ID: ${this.agent.walletId}.<br>A notification has been sent via email.`,
        confirmButtonColor: "#00c307",
        confirmButtonText: "Back To KYC",
      });
    },
    async handleApproveKYC() {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/approve/${this.agent._id}`,
          null,
        );

        const { message, status } = response.data;

        if (status === "success") {
          this.agent.verifiedStatus = "verified";

          Swal.fire({
            icon: status,
            title: "KYC Approved",
            html: `<p>You have approved the KYC submission for <strong>${this.agent.firstName} ${this.agent.lastName}</strong> with assigned Wallet ID: <strong>${this.agent.walletId}</strong>.</p>`,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to approve KYC. Please try again later.",
        });
      }
    },
    async handleRejectKYC() {
      if (!this.defaultReason) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Please select a default reason.",
        });
        return;
      }

      const payload = {
        reason: this.defaultReason,
      };

      try {
        await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/decline/${this.agent._id}`,
          payload,
        );

        this.agent.verifiedStatus = "rejected";

        Swal.fire({
          icon: "error",
          title: "KYC REQUEST REJECTED",
          html: `<p>You have rejected the KYC submission for <strong>${this.agent.firstName}</strong> with assigned Wallet ID: <strong>${this.agent.walletId}</strong></p> <p>A notification has been sent via email.</p>`,
        });
        this.showModal = false;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to reject KYC. Please try again later.",
        });
      }
    },
    async getAgent() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/agent/${this.$route.params.agentId}`,
        );

        if (!response || !response.data || !response.data.agent) {
          throw new Error("Invalid response from server");
        }

        const safeGet = (obj, path, defaultValue = "") => {
          return path
            .split(".")
            .reduce(
              (acc, k) => (acc && acc[k] !== undefined ? acc[k] : defaultValue),
              obj,
            );
        };

        const { agent } = response.data;

        this.agent = {
          ...agent,
          socialMediaHandle: safeGet(agent, "socialMedia.socialMediaHandle"),
          socialMediaPlatform: safeGet(
            agent,
            "socialMedia.socialMediaPlatform",
          ),
        };
      } catch (err) {
        const errorMessage =
          err.response.data.message ||
          err.message ||
          "Unable to Fetch Agent Data";

        this.setNotification({ type: "danger", message: errorMessage });
      }
    },
    async getAmlCheck() {
      try {
        this.loading.show = true;
        this.amlCheck = false;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/aml/check/${this.agent._id}`,
        );

        const { data } = response.data;

        if (response.data.status === "success") {
          this.amlCheck = true;
          this.amlDetails = data;
        }
      } catch (error) {
        this.loading.show = false;
        Swal.fire("Error", "Failed to fetch AML data.", "error");
      } finally {
        this.loading.show = false;
      }
    },

    async checkData() {
      this.loading.show = true;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/agent/${this.agent._id}`,
        );
        console.log("check data", response.data.agent.data);

        const res = response.data.agent.data;

        if (res && res.business_data) {
          this.amlCheck = true;
          this.amlDetails = res;
        } else {
          this.amlCheck = false;
        }
      } catch (error) {
        this.error = true;
        this.errorMsg =
          error.response && error.response.data
            ? error.response.data.message
            : "An unknown error occurred.";
        console.error("Error fetching data:", error);
      } finally {
        this.loading.show = false;
      }
    },
  },
  async mounted() {
    await this.getAgent();
    this.checkData();
  },
};
</script>

<style>
label {
  color: #9a9a9a !important;
  font-size: 10px;
}

select {
  background-color: #fafafa;
  font-size: 10px;
}

select::placeholder {
  color: #b6b6b4 !important;
}

select:disabled {
  background-color: #f5f5f5;
  color: #cecece;
}

button:disabled {
  opacity: 50%;
  cursor: not-allowed;
}

.heading {
  font-size: 18px;
  color: #000000;
  font-weight: 700;
  margin: 40px 0 15px;
}

.no-info {
  font-size: 12px;
}

.kyc-file > label:disabled {
  background-color: pink !important;
}

.info-wrap {
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.personal-details h4 {
  font-weight: 700;
  font-size: 20px;
  color: #000;
}

.file-label {
  background-color: #f4f4f4;
  color: #66615c;
  border: 1px solid #eaeaea;
  padding: 10px 10px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 4px;
}

.file-label:hover {
  background-color: #f4f4f4;
}

.file-label.disabled {
  background-color: #f5f5f5 !important;
  color: #cecece !important;
  cursor: not-allowed;
}

.kyc-uploaded h4 {
  color: #000;
  font-size: 20px;
  font-weight: 700 !important;
  margin-bottom: 30px;
}

.kyc-uploaded p {
  color: #000;
  font-size: 12px;
  font-weight: 600 !important;
}

.update-btn {
  gap: 8px;
}

.account p {
  font-size: 12px;
  font-weight: 700;
  background-color: #f5f5f5;
  color: #66615c !important;
  padding: 0 0 0 10px;
  border-radius: 4px;
  height: 40px;
  width: 200px;
  margin-bottom: 0px !important;
}

.tab-items {
  display: flex;
  padding: 0 !important;
  border-bottom: 0.5px solid #9a9a9a;
  position: relative;
  overflow-x: auto;
  white-space: nowrap;
}

.tab-btn {
  font-weight: 600;
  word-spacing: 1px;
  font-size: 10px;
  letter-spacing: 0.5px;
  color: #fff;
  height: fit-content;
  padding: 10px 20px;
  border: none !important;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 700 !important;
}

.section-button {
  border: none;
  padding: 1rem;
  margin: 0 !important;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  color: #9a9a9a;
  position: relative;
  background-color: transparent;
}

.section-button::after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1.5px;
  background-color: transparent;
  transition: all 0.3s ease;
}

.section-button:hover::after {
  width: 100%;
  background-color: #000;
}

.section-button.active {
  color: #1eb75b !important;
}

.section-button.active::after {
  width: 100%;
  background-color: #4cbb17;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.styled-button {
  width: 162px;
  height: 41px;
  padding: 8px 0 0 0;
  gap: 8px;
  border-radius: 100px 0 100px 0;
  opacity: 0;
}

.status {
  width: 200px;
  padding: 8px 0 8px 8px;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  word-spacing: 0.1px;
  font-weight: 600;
}

.verified {
  background-color: #4cbb17;
}

.unverified {
  background-color: #4b61d1;
}

.pending {
  background-color: #ffd700;
}

.rejected {
  background-color: #ff0800;
}

.btn-rejected {
  background-color: #ff0800 !important;
  border: #ff0800 !important;
}

.btn-approve {
  background-color: #4cbb17 !important;
  border-color: #4cbb17 !important;
}

.btn-normal {
  border: none;
  background-color: #0055d4;
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: bolder;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 1px;
  cursor: pointer;
}

.btn-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 18px;
}

.preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.documents-container p {
  text-align: center;
  text-transform: uppercase;
  font-size: 10px !important;
}

.document-wrapper {
  position: relative;
  width: 80%;
  margin: auto;
  transition: all 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center !important;
}

.document-wrapper.hovered {
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.uploaded-img {
  width: 100%;
  height: 140px;
  object-fit: cover;
}

.pdf-preview-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdf-preview-container img {
  width: 80px;
  height: 80px;
}

.btn-preview {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 8px;
}

.btn-download {
  display: inline-block;
  width: fit-content;
  background-color: #000;
}

.cont {
  background-color: #fff;
  min-height: 100vh;
  border-radius: 8px;
  padding: 30px !important;
  display: flex;
  flex-direction: column;
  gap: 20px 0px;
}

.kyc-status-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.kyc-status {
  font-weight: 500 !important;
  font-size: 16px !important;
  margin: 0 !important;
}

.head-three {
  font-weight: 700 !important;
  font-size: 20px;
  color: #000;
  margin: 0 !important;
}

.head-five {
  margin: 0 !important;
}

.aml-item {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.img-test {
  width: 30%;
  height: 30%;
}

.documents-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 40px !important;
}

.documents-container p {
  color: #000;
  font-size: 12px;
}

.centralized {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40vh;
}

.sub-heading {
  font-weight: 700 !important;
  color: #000;
}

.view-more {
  display: block;
  margin: 20px 0;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #4cbb17;
  text-transform: capitalize;
  cursor: pointer;
}

.spin {
  border: 4px solid rgba(101, 179, 199, 0.2);
  border-left-color: #65b3c7;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

.Vue-Toastification__toast--success.my-custom-toast-class {
  background-color: #ecfef2;
  color: #008200;
  border: 1px solid #c2fddb;
}

.Vue-Toastification__toast--error.my-custom-toast-class {
  background-color: #ffeff0;
  color: #e30000;
  border: 1px solid #fee1e2;
}
.Vue-Toastification__toast.my-custom-toast-class {
  box-shadow: none;
}

.Vue-Toastification__toast-body.custom-class-1 {
  font-size: 14px;
  font-weight: 500;
}

button.custom-close-btn {
  color: inherit;
  background: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

/* .modal-content {
	padding: 56px 64px;
} */

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
